import { Authenticated, Refine } from "@refinedev/core";
import routerProvider from "@refinedev/react-router";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router";

import { AppLayout } from "@/components/layout/AppLayout";
import { authProvider, dataProvider, HOME } from "@/lib/providers";
import { BANKS, ENTREPRENEURS } from "@/lib/statements";
import { AccountsPage } from "@/pages/AccountsPage";
import { AcquiringPage } from "@/pages/AcquiringPage";
import { BankServicePage } from "@/pages/BankServicePage";
import { CashPage } from "@/pages/CashPage";
import { CounterpartiesPage } from "@/pages/CounterpartiesPage";
import { CoveragePage } from "@/pages/CoveragePage";
import { CrmArticlesPage } from "@/pages/CrmArticlesPage";
import { DirectoryPage } from "@/pages/DirectoryPage";
import { CollectionPage } from "@/pages/CollectionPage";
import { DeliveryPage } from "@/pages/DeliveryPage";
import { KassaPage } from "@/pages/KassaPage";
import { LoginPage } from "@/pages/LoginPage";
import { OperationsPage } from "@/pages/OperationsPage";
import { ExpensesPage } from "@/pages/ExpensesPage";
import { PaymentsPage } from "@/pages/PaymentsPage";
import { PayrollPage } from "@/pages/PayrollPage";
import { PermissionsPage } from "@/pages/PermissionsPage";
import { PersonalFinancePage } from "@/pages/PersonalFinancePage";
import { PnlPage } from "@/pages/PnlPage";
import { RegistriesPage } from "@/pages/RegistriesPage";
import { RulesPage } from "@/pages/RulesPage";
import { StatementsPage } from "@/pages/StatementsPage";

export function App() {
  return (
    <BrowserRouter>
      <Refine
        dataProvider={dataProvider}
        authProvider={authProvider}
        routerProvider={routerProvider}
        options={{ disableTelemetry: true, warnWhenUnsavedChanges: true }}
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              /* Незалогиненный не должен видеть каркас даже мгновение. */
              <Authenticated key="app" fallback={<Navigate to="/login" replace />}>
                <AppLayout>
                  <Outlet />
                </AppLayout>
              </Authenticated>
            }
          >
            <Route index element={<Navigate to={HOME} replace />} />
            <Route path="/statements" element={<StatementsPage />} />
            <Route path="/statements/coverage" element={<CoveragePage />} />
            <Route path="/statements/entrepreneurs" element={<DirectoryPage key="entrepreneurs" kind={ENTREPRENEURS} />} />
            <Route path="/statements/banks" element={<DirectoryPage key="banks" kind={BANKS} />} />
            <Route path="/pnl" element={<PnlPage />} />
            <Route path="/pnl/operations" element={<OperationsPage />} />
            <Route path="/pnl/payments" element={<PaymentsPage />} />
            <Route path="/pnl/expenses" element={<ExpensesPage />} />
            <Route path="/pnl/payroll" element={<PayrollPage />} />
            <Route path="/pnl/bank-service" element={<BankServicePage />} />
            <Route path="/pnl/counterparties" element={<CounterpartiesPage />} />
            <Route path="/pnl/accounts" element={<AccountsPage />} />
            <Route path="/pnl/acquiring" element={<AcquiringPage />} />
            <Route path="/pnl/rules" element={<RulesPage />} />
            <Route path="/payroll/registries" element={<RegistriesPage />} />
            <Route path="/cash" element={<CashPage />} />
            <Route path="/kassa" element={<KassaPage />} />
            <Route path="/control/collection" element={<CollectionPage />} />
            <Route path="/control/delivery" element={<DeliveryPage />} />
            <Route path="/kassa/articles" element={<CrmArticlesPage />} />
            <Route path="/settings/permissions" element={<PermissionsPage />} />
            <Route path="/personal" element={<PersonalFinancePage />} />
          </Route>
        </Routes>
      </Refine>
    </BrowserRouter>
  );
}
